<template>
    <div class="share-bot">
        <button class="font-28 color-f" @click="open">打开APP</button>
    </div>
</template>

<script>
export default {
    methods: {
        open() {
            var ua = window.navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == 'micromessenger' || ua.match(/_SQ_/i) == '_sq_') {
                this.$store.commit('updateMask', true)
                return
            }
            this.launchApp('', 'https://rencaiw.bjsdcx.com')
        },
        launchApp(androidurl, iosUrl, delay = 3000) {
            const Navigator = navigator.userAgent;
            const ifIos = Navigator.match(/iPhone|iPad|iPd/i) ? true : false;
            const ifAndroid = (Navigator.match(/(Android);?[\s\/]+([\d.]+)?/)) ? true : false;
            let iosVersion = Navigator.match(/OS\s*(\d+)/);
            iosVersion = iosVersion ? (iosVersion[1] || 0) : 0;
            let androidVersion = Navigator.match(/Android\s*(\d+)/)
            androidVersion = androidVersion ? (androidVersion[1] || 0) : 0;
            const ifSafari = Navigator.indexOf('Safari') > -1;
            let timer;
            let openIosUrl = 'https://rencaiw.bjsdcx.com'
            let openAndroidUrl = 'rencaizhiye://app/toLauncherApp'
            let openUrl = ''
            if (ifAndroid) {
                openUrl = openAndroidUrl
            } else {
                openUrl = openIosUrl
            }

            function openApp(androidUrl, iosUrl) {
                if (ifAndroid && androidVersion >= 5) {
                    window.location.href = openUrl;
                    setTimer(androidUrl)
                } else if (ifIos && iosVersion >= 9) {
                    if (ifSafari) {
                        const a = document.createElement('a');
                        a.href = openUrl;
                        a.click();
                        setTimer(iosUrl)
                    } else {
                        window.location.href = openUrl;
                        setTimer(iosUrl)
                    }
                } else {
                    let download = '';
                    if (ifIos) {
                        download = iosUrl
                    } else if (ifAndroid) {
                        download = androidUrl
                    }
                    const ifr = document.createElement('iframe');
                    ifr.src = openUrl;
                    ifr.style.display = 'none';
                    document.body.appendChild(ifr);
                    setTimer(download)
                }

                function fn() {
                    clearTimeout(timer);
                    document.removeEventListener('visibilitychange', fn);
                }

                document.addEventListener('pagehide', function () {
                    clearTimeout(timer);
                });
            }

            function setTimer(downloadUrl) {
                timer = setTimeout(function () {
                    const tag = document.hidden || document.webkitHidden;
                    if (tag) {
                        clearTimeout(timer);
                    } else {
                        window.location.href = downloadUrl;
                    }
                }, delay);
            }

            openApp(androidurl, iosUrl, openUrl);

        }
    }
}
</script>

<style lang="scss" scoped>
$main-color: #0095DF;

.share-bot {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    max-width: 750px;
    margin: 0 auto;
    background-color: #FFFFFF;
    padding: .3rem .3rem .5rem;
    box-shadow: 0 -.1rem .1rem rgba($color: $main-color, $alpha: 0.1);
    border-radius: .3rem .3rem 0 0;
    text-align: center;

    button {
        display: block;
        width: 6.3rem;
        height: 1rem;
        background: $main-color;
        border-radius: .5rem;
        margin: 0 auto;
        cursor: pointer;
    }
}
</style>
